import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";

var styles = {
  relative: {
    cursor: "pointer",
    position: "relative",
    width: "25px",
    height: "25px",
  },
  emoji: {
    width: "23px",
    height: "23px",
  },
  selectedEmoji: {
    width: "100%",
    height: "100%",
  },
  everyEmoji: {
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  emojiList: {
    display: "flex",
    paddingBottom: "8px",
    paddingTop: "8px",
    listStyle: "none",
  },
  boxShadow: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    background: "white",
  },
};

export default ({ buzzes, selectedBuzzData }) => {
  const classes = styles;
  const [showMoods, setShowMoods] = useState(null);
  let selectedMood;

  const showMoodsPooper = (event) => {
    setShowMoods(event.currentTarget);
  };

  const hideMoodsPooper = () => {
    setShowMoods(null);
  };

  const updateReaction = (newReactionId, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    setShowMoods(null);
    selectedBuzzData(newReactionId);
  };

  selectedMood = selectedMood ? (
    <img
      className="mwh-25"
      style={classes.selectedEmoji}
      src={selectedMood.media}
      alt={selectedMood.name}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSmile}
      style={classes.selectedEmoji}
      className="mw-25 icon-light"
    />
  );

  return (
    <span
      className="p-smilies"
      style={classes.relative}
      onMouseEnter={showMoodsPooper}
      onClick={showMoodsPooper}
      onMouseLeave={hideMoodsPooper}
    >
      {selectedMood}
      <CSSTransition
        in={Boolean(showMoods)}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={hideMoodsPooper}>
          <div style={classes.boxShadow} className="waterCoolerReaction">
            <ul style={classes.emojiList}>
              {buzzes.map((mood) => (
                <li
                  onClick={(e) => updateReaction(mood.id, e)}
                  key={mood.name}
                  style={classes.everyEmoji}
                >
                  <img
                    src={mood.media}
                    alt={mood.name}
                    key={mood.id}
                    style={classes.emoji}
                  />
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </span>
  );
};
